//当前用户yr
import axios from './index.js'
export async function currentUserFilePath(groupId, path, userName) {
  return axios.get('/system/api/file/userfiles', {
    params:{
      groupId,
      path,
      userName
    }
  })
}

// getShareUrls
export async function getShareUrls(path, userName) {
  return axios.get('/system/api/file/getShareUrls', {
    params:{
      path,
      userName
    }
  })
}


